import { useEffect, useState } from "react";

import { useAppContext } from "@app/helpers/hooks";
import type { RegionType } from "@app/services/geo-data-service";

type State = {
  value: string;
  label: string;
};

export function useRegionDetails(
  country_code: string
): [RegionType | null, State[]] {
  const { geoData } = useAppContext();

  const [region_type, setRegionType] = useState<RegionType | null>(
    geoData.getRegionsType(country_code)
  );
  const [region_options, setRegionOptions] = useState<State[]>(
    geoData
      .getRegions(country_code)
      .map(region => ({ value: region.value, label: region.name }))
  );

  useEffect(() => {
    setRegionOptions(
      geoData
        .getRegions(country_code)
        .map(region => ({ value: region.value, label: region.name }))
    );
    setRegionType(geoData.getRegionsType(country_code));
  }, [country_code]);

  return [region_type, region_options];
}
